/**
 * Utility function for merging Tailwind CSS classes
 * 
 * @author Varun Pandey
 */

import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
